module.exports = __webpack_public_path__ + "static/media/blog7_big.6a3f3194.webp";